<div class="mapping-modal">
	<div class="mapping-modal__header">
		<div>
			<h2 class="fw-bold fs-xs">Confirmar mapeamento das colunas</h2>
			<p class="fs-xxs gray">
				Revise as sugestões e ajuste as colunas de cada arquivo ou aba antes de
				continuar.
			</p>
		</div>
		<button mat-icon-button type="button" (click)="onCancel()">
			<mat-icon>close</mat-icon>
		</button>
	</div>

	<form class="mapping-modal__content" [formGroup]="form">
		<div formArrayName="sources">
			<section
				class="mapping-source"
				*ngFor="
					let sourceForm of sourceForms;
					let sourceIndex = index;
					trackBy: trackByIndex
				"
				[formGroupName]="sourceIndex"
			>
				<div class="mapping-source__header">
					<div>
						<h3 class="fw-bold fs-xxs">
							{{ data.analysis.sources[sourceIndex].fileName }}
						</h3>
						<p class="fs-xxxs gray">
							Aba {{ data.analysis.sources[sourceIndex].sheetName }} -
							{{ data.analysis.sources[sourceIndex].rowCount }} linha(s)
						</p>
					</div>

					<mat-form-field appearance="outline">
						<mat-label>Uso da fonte</mat-label>
						<mat-select formControlName="usage">
							<mat-option [value]="sourceUsage.USE">Usar</mat-option>
							<mat-option [value]="sourceUsage.IGNORE">Ignorar</mat-option>
						</mat-select>
					</mat-form-field>
				</div>

				<div
					class="mapping-source__ignored"
					*ngIf="isSourceIgnored(sourceIndex)"
				>
					Esta fonte será enviada como ignorada no mapeamento confirmado.
				</div>

				<div class="mapping-source__body" *ngIf="isSourceUsed(sourceIndex)">
					<div class="mapping-source__controls">
						<mat-form-field appearance="outline">
							<mat-label>Tipo de benefício</mat-label>
							<mat-select formControlName="benefitKind">
								<mat-option
									*ngFor="
										let option of benefitKindOptions;
										trackBy: trackByOptionValue
									"
									[value]="option.value"
								>
									{{ option.label }}
								</mat-option>
							</mat-select>
						</mat-form-field>

						<mat-form-field appearance="outline">
							<mat-label>Titularidade</mat-label>
							<mat-select formControlName="titularityKind">
								<mat-option
									*ngFor="
										let option of titularityKindOptions;
										trackBy: trackByOptionValue
									"
									[value]="option.value"
								>
									{{ option.label }}
								</mat-option>
							</mat-select>
						</mat-form-field>
					</div>

					<div class="mapping-fields">
						<div
							class="mapping-field"
							*ngFor="
								let field of getVisibleFieldMetadata(sourceIndex);
								trackBy: trackByField
							"
						>
							<div class="mapping-field__label">
								<span>
									{{ field.label }}
									<span
										class="mapping-field__required-mark"
										*ngIf="isFieldRequired(sourceIndex, field.value)"
									>
										*
									</span>
								</span>
							</div>

							<mat-form-field appearance="outline">
								<mat-label>Coluna</mat-label>
								<mat-select
									[formControl]="getFieldControl(sourceIndex, field.value)"
								>
									<mat-option value="">Pendente</mat-option>
									<mat-option
										*ngFor="
											let column of getSourceOptionColumns(
												data.analysis.sources[sourceIndex]
											);
											trackBy: trackByColumn
										"
										[value]="getColumnOptionValue(column.sourceName)"
									>
										{{ getColumnDisplayLabel(column) }}
									</mat-option>
									<mat-option
										*ngIf="
											shouldShowMissingFromSourceOption(
												sourceIndex,
												field.value
											)
										"
										[value]="
											getFieldStateOptionValue(fieldState.MISSING_FROM_SOURCE)
										"
									>
										{{ getSpecialStateLabel(fieldState.MISSING_FROM_SOURCE) }}
									</mat-option>
									<mat-option
										*ngIf="
											shouldShowNotApplicableOption(sourceIndex, field.value)
										"
										[value]="
											getFieldStateOptionValue(fieldState.NOT_APPLICABLE)
										"
									>
										{{ getSpecialStateLabel(fieldState.NOT_APPLICABLE) }}
									</mat-option>
								</mat-select>
							</mat-form-field>
						</div>
					</div>
				</div>
			</section>
		</div>
	</form>

	<p class="error-message fs-xxs" *ngIf="errorMessage">{{ errorMessage }}</p>

	<div class="mapping-modal__actions">
		<button
			mat-stroked-button
			color="primary"
			type="button"
			(click)="onCancel()"
		>
			Cancelar
		</button>
		<button mat-flat-button color="primary" type="button" (click)="onConfirm()">
			Confirmar mapeamento
		</button>
	</div>
</div>
